import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../auth/useAuth';
import { userConfigService } from '../../services/UserConfigService';
import { userConfigQueryKeys } from '../userConfigQueryKeys';

export function useUserConfigQuery() {
  const { isAuthenticated, isLoading } = useAuth();
  const isEnabled = !isLoading && isAuthenticated;

  return useQuery({
    queryKey: userConfigQueryKeys.config(),
    enabled: isEnabled,
    queryFn: () => userConfigService.getConfig(),
  });
}
